import React from 'react';
import classes from './Modals.css';
import { Checkbox } from '@material-ui/core';

const HideColumns = ({ onhideColumns, hideColumns, onClose, showClassification, showContact }) => {
   
    return (
    <div className={classes.container}>
        <h4 className={classes.heading}>Display Columns</h4>
        <div className={[classes.content, classes.w200].join(' ')}>
            <div>
               <Checkbox checked={!hideColumns.reference} onChange={(value) => onhideColumns('reference', value)} color="primary" /> Reference
            </div>
            <div>
                <Checkbox checked={!hideColumns.type} onChange={(value) => onhideColumns('type', value)} color="primary" /> Type
            </div>
            <div>
                <Checkbox checked={!hideColumns.quantity} onChange={(value) => onhideColumns('quantity', value)} color="primary" /> Quantity
            </div>
            {showClassification && <div>
                <Checkbox checked={!hideColumns.classification} onChange={(value) => onhideColumns('classification', value)} color="primary" /> Classification
            </div>}
            {showContact && <div>
                <Checkbox checked={!hideColumns.contact} onChange={(value) => onhideColumns('contact', value)} color="primary" /> Contact
            </div>}
        </div>
        <hr />
        <div>
            <button type="button" onClick={onClose} className={[classes.btn, classes.btnDefault].join(' ')}>Close</button>
        </div>
    </div>
    );
}

export default HideColumns;



// WEBPACK FOOTER //
// ./src/components/Modals/HideColumns.js